import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Loading from 'components/loading/Loading';

export function TagFilterDropdown(props) {
  const { currentTag, tagCategories, selectedIds, onSelectedTagAdd } = props;
  const { t } = useTranslation();

  const handleSelectedTagAdd = (id) => {
    onSelectedTagAdd(id);
  };

  const renderFilteredTags = (tagCategory) => {
    return tagCategory.tags
      .filter(
        (tag) =>
          tag.value.includes(currentTag) ||
          tagCategory.title.includes(currentTag)
      )
      .map(({ id, value }) => (
        <li
          key={id}
          onClick={() => handleSelectedTagAdd(id)}
          className={classNames({ selected: selectedIds.includes(id) })}
        >
          <label>{value}</label>
          <span>
            {t('content:category')} : {tagCategory.title}
          </span>
        </li>
      ));
  };

  return (
    <ul data-testid='filter-content-tag-tags'>
      {tagCategories.length &&
        tagCategories.map((tagCategory) => renderFilteredTags(tagCategory))}
      {tagCategories.loading && (
        <li className='loading-section'>
          <Loading spinning={true} />
        </li>
      )}
    </ul>
  );
}

TagFilterDropdown.propTypes = {
  currentTag: PropTypes.string,
  tagCategories: PropTypes.array,
  selectedIds: PropTypes.array,
  onSelectedTagAdd: PropTypes.func,
};
